import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { mapObjectKeys } from 'utils/ramdaAdditions';
import withFormItem from 'components/hocs/withFormItem';
import { getDictionaries } from 'actions/asyncActions';

@withFormItem
@withAsyncActions(({ dictionary }) => ({
    getDictionaries: getDictionaries
        .withOptions({ dispatchOnMount: !!dictionary })
}))
export default class SelectComponent extends Component {
    static propTypes = {
        placeholder: PropTypes.string,
        allowClear: PropTypes.bool,
        options: PropTypes.array,
        path: PropTypes.string,
        dictionary: PropTypes.string,
    };

    static defaultProps = {
        options: [],
        path: 'id',
        namePath: 'name'
    };

    renderDictOptions(dict) {
        const options = [];

        mapObjectKeys(value => options.push({
            value,
            label: dict[value]
        }), dict);

        return options.map(({ value, label }, index) => (
            <Select.Option key={index} value={value}>
                {label}
            </Select.Option>
        ));
    }

    renderOptions() {
        const { options, path, namePath } = this.props;

        return options.map((option, index) => (
            <Select.Option key={index} value={option[path]}>
                {option[namePath]}
            </Select.Option>
        ));
    }

    onChange = value => this.props.form.setFieldValue(this.props.field.name, value);

    render() {
        const { field: { value }, dictionary, getDictionaries: { data }, ...props } = this.props;
        const dict = data[dictionary];
    
        return (
            <Select
                value={value}
                onChange={this.onChange}
                {...props}
                dropdownStyle={{width: '100%'}}
                getPopupContainer={trigger => trigger.parentNode}
            >
                { dict ? this.renderDictOptions(dict) : this.renderOptions() }
            </Select>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/form/Select.js